export default {
    key: 'hotel',
    common: {
        productName: 'core.productNames.hotel',
        splashMessage: 'offerFlow.splashMessage.hotel',
        headingAside: 'offerFlow.headingAside.hotel',
    },
    stepAccommodationDate: {
        heading: 'offerFlow.pages.stepAccommodationDate.heading',
        body: 'offerFlow.pages.stepAccommodationDate.body',

    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.hotel',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
    stepAccommodationResidents: {
        heading: 'offerFlow.pages.stepAccommodationResidents.heading',
    },
} satisfies OfferFlowContent;
